import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import { useIntl } from "react-intl";
import { connect } from "react-redux";

import Card from "../../UI/Card/CardChannel";
import * as ChannelActions from "../../../middleware/Store/Actions/ChannelActions";
import * as ChannelUtils from "../../Utils/ChannelUtils";
import Spinner from "../../UI/Spinner/Spinner";
import Items from "./ChannelItem";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "CARD_CHANNEL";

const Channel = (props) => {
    const intl = useIntl();

    useEffect(() => {
        if (props.channel && props.isChannelSubscribed) {
            LogService.trace(LOG_TAG, "Refresh channel items...");
            props.getItemsFromChannel();
        }
    }, []);
        
    let title = ChannelUtils.getName(props.channel);
    let creator = ChannelUtils.getCreator(props.creator);
    let lastUpdated = ChannelUtils.lastUpdated(props.status, intl);
    
    let items = <Spinner />;
    if (props.items && props.items.length > 0) {
        items = props.items.map((item, index) => (
            <Items key={index}
                date={intl.formatDate(item?.timestamp, { year: "numeric", month: "long", day: "numeric", hour:"numeric", minute: "numeric"})}
                publisher={ChannelUtils.getPublisherName(item, props.contacts)}
                attachments = {props.attachments}
                images = {props.images}
                avatar={ChannelUtils.getAvatar(item, props.contacts)}
                entry={item.entry}
            />
        ));
    }

    return (
        <Card
            title={title}
            creator={creator}
            footer={lastUpdated}
        >
            { items }
        </Card>
    );
}

Channel.propTypes = {
    channel: PropTypes.object,
    items: PropTypes.array,
    status: PropTypes.object,
    creator: PropTypes.object,
    isChannelSubscribed: PropTypes.bool
}

const mapStateToProps = state => {
    return {
        channel: state.channel.data,
        user: state.contacts.user,
        items: state.channel.items,
        status: state.channel.status,
        creator: ChannelUtils.getContactById(state.channel.data?.creatorId, [...state.contacts.contacts, state.contacts.user]),
        contacts: [...state.contacts.contacts, state.contacts.user],
        attachments: state.channel.attachments, 
        images: state.channel.images,
        isChannelSubscribed: ChannelUtils.isSubscribed(state.channel)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getItemsFromChannel: () => dispatch(ChannelActions.getItemsFromChannel())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Channel);